<template>
  <div class="navbar-burger is-hidden-desktop" :class="{ 'is-active': isOpen }">
    <button
      role="button"
      class="button-reset burger"
      aria-label="menu"
      aria-expanded="false"
      @click="emit('toggle')"
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect id="burger-icon-top" x="12" y="16" width="24" height="2" />
        <rect id="burger-icon-middle-a" x="12" y="23" width="24" height="2" />
        <rect id="burger-icon-middle-b" x="12" y="23" width="24" height="2" />
        <rect id="burger-icon-bottom" x="12" y="30" width="24" height="2" />
      </svg>
      <span class="belowTablet:!hidden">Menü</span>
    </button>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    isOpen?: boolean
  }>(),
  {
    isOpen: false,
  },
)

const emit = defineEmits<{
  (e: 'toggle'): void
}>()
</script>

<style lang="postcss">
.navbar-burger {
  @apply fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;

  button {
    @apply box-content block rounded-full border-4 border-solid border-background bg-button-color text-scheme-main;
    width: 3rem;
    height: 3rem;
    svg {
      @apply box-border block;
    }
  }
  @apply tablet:absolute;
  @screen tablet {
    bottom: initial;
    top: 0.75rem;

    left: initial;
    right: 1rem;
    transform: none;

    &:not(.is-active) {
      body.has-hero-image & {
        svg {
          fill: #fff;
        }
      }
    }
  }

  &:not(.is-active) {
    body.has-hero-image & {
      @apply tablet:text-white;
    }
  }

  button {
    @apply tablet:flex tablet:w-auto tablet:items-center tablet:rounded-none tablet:border-0 tablet:bg-transparent tablet:text-size-5 tablet:font-bold tablet:text-scheme-invert;
  }

  svg {
    rect {
      transition: 0.5s;
    }
    #burger-icon-middle-a,
    #burger-icon-middle-b {
      transform-box: fill-box;
      transform-origin: center;
    }
  }

  &.is-active {
    svg {
      #burger-icon-top {
        opacity: 0;
      }
      #burger-icon-bottom {
        opacity: 0;
      }
      #burger-icon-middle-a {
        transform: rotate(45deg);
      }
      #burger-icon-middle-b {
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
